export const UiActionCreators = {
  toggleSideBarCalculator: () => ({ type: "TOGGLE_SIDEBAR_CALCULATOR" }),
  showSideBarCalculator: (show) => ({
    type: "SHOW_SIDEBAR_CALCULATOR",
    payload: show,
  }),
};
